import Button from "@edaz/edazkit/Button";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import type { ViewComponent } from "@frui.ts/views";
import { preventDefault, registerView } from "@frui.ts/views";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import { observer } from "mobx-react-lite";
import React from "react";
import { ButtonToolbar, Col, Form, Modal } from "react-bootstrap";
import FaultyCombinationDetailViewModel from "viewModels/users/accessRights/faultyCombinations/faultyCombinationDetailViewModel";

const FaultyCombinationDetailView: ViewComponent<FaultyCombinationDetailViewModel> = observer(({ vm }) => {
  const disabled = !vm.isEditable;

  return (
    <Modal show centered onHide={vm.cancel}>
      <Form onSubmit={preventDefault(vm.save)}>
        <Modal.Header>
          <Modal.Title>{vm.item && vm.permissionArea.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LoaderOverlay loading={!vm.item} style={{ minHeight: 150 }}>
            {vm.item && (
              <>
                <Form.Row>
                  <FormGroup as={Col} target={vm} property="area">
                    <FormLabel>{vm.translate("addCombination")}</FormLabel>
                    <AdvancedSelect
                      items={vm.areaOptions}
                      mode="key"
                      disabled={disabled}
                      placeholder={vm.translate("typeToSearch")}
                    />
                  </FormGroup>
                </Form.Row>
                <Form.Row>
                  <FormGroup as={Col} target={vm} property="area">
                    <FormLabel>{vm.translateAttribute("faultyCombinations")}</FormLabel>
                    <div className="mt-2">
                      {vm.combinations.map(combination => (
                        <span key={combination.id} className="bg-danger-light rounded d-inline-block px-3 py-2 mr-2 mb-2">
                          {combination.name}
                          <Icon
                            icon={IconType.Cross}
                            width={15}
                            height={15}
                            className="ml-2 text-danger cursor-pointer"
                            onClick={() => vm.removeCombination(combination.id)}
                          />
                        </span>
                      ))}
                      {!vm.combinations.length && <span className="text-muted">{vm.translate("noCombinations")}</span>}
                    </div>
                  </FormGroup>
                </Form.Row>
              </>
            )}
          </LoaderOverlay>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className="justify-content-center w-100">
            <div className="row w-100">
              <div className="col">
                <Button size="sm" block={true} onClick={vm.cancel} type="reset" variant="light">
                  {vm.translateGeneral("cancel")}
                </Button>
              </div>
              {vm.isEditable && (
                <div className="col">
                  <Button size="sm" block={true} type="submit" disabled={vm.busyWatcher.isBusy}>
                    {vm.translateGeneral("save")}
                  </Button>
                </div>
              )}
            </div>
          </ButtonToolbar>
        </Modal.Footer>
      </Form>
    </Modal>
  );
});

registerView(FaultyCombinationDetailView, FaultyCombinationDetailViewModel);
